import React from 'react';
import PropTypes from 'prop-types';
import * as colors from 'material-ui/styles/colors';
import OrderStatus from 'orderStatusComponents/OrderStatus';
import {FormattedTime} from 'react-intl';
import moment from 'moment';
import * as orderStatusUtils from 'utils/orderStatusUtils';

const OrderStatusBar = (props) => {

    const {orderStatus, duration} = props;

    if (!orderStatus) {
        return null;
    }

    if (orderStatus.get('loading')) {
        return (
            <h6 style={{
                padding: '10px'
            }}>Loading Order Status...</h6>
        );
    }

    let orderStatusItem = null;

    const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

    if (orderStatusList) {
        orderStatusItem = orderStatusList.first();
    } else {
        return null;
    }

    let color = '',
        foreColor = '',
        labelColor = colors.grey500;

    if (orderStatusUtils.isAssignedState(orderStatus)) {
        color = colors.white;
        foreColor = colors.black;

    }
    if (orderStatusUtils.isInProgressState(orderStatus)) {
        color = colors.green400;
        foreColor = colors.white;
        labelColor = colors.lightWhite;
    }

    if (orderStatusUtils.isFinalState(orderStatus)) {
        color = colors.grey400;
        foreColor = colors.white;
        labelColor = colors.lightWhite;
    }

    const timeStyle = {};
    let endTime = null,
        startTime = null;
    
    
    // if (!orderStatusItem.get('estimatedEarliestStartTime')) {
    //     timeStyle.display = 'none';
    // } else {
    //     startTime = (<FormattedTime value={orderStatusItem.get('estimatedEarliestStartTime')}/>);
    //     endTime = (<FormattedTime
    //         value={moment(orderStatusItem.get('estimatedEarliestStartTime')).add(parseInt(duration), 'm').toDate()}/>);
    // }
    
    //estimatedTimeOfArrival
    if (!orderStatusItem.get('estimatedArrivalTime')) {
        timeStyle.display = 'none';
    } else {
        startTime = (<FormattedTime value={orderStatusItem.get('estimatedArrivalTime')}/>);
        endTime = (<FormattedTime
            value={moment(orderStatusItem.get('estimatedArrivalTime')).add(parseInt(duration), 'm').toDate()}/>);
    }

    return (
        <div
            style={{
            backgroundColor: color,
            color: foreColor,
            width: '100%',
            height: '60px',
            padding: '10px'
        }}>
            <div className="left">
                <label
                    style={{
                    color: labelColor,
                    fontSize: '12px',
                    paddingRight: '5px'
                }}>Status:</label>
                <span style={{
                    fontSize: '12px'
                }}>
                    <OrderStatus currentStatus={orderStatusItem.get('dispatchStatus')}/>
                </span>
            </div>
            <div className="right" style={timeStyle}>
                <label
                    style={{
                    color: labelColor,
                    fontSize: '12px',
                    paddingRight: '5px'
                }}>Expected time:</label>
                <span style={{
                    fontSize: '12px'
                }}>
                    {startTime} - {endTime}
                </span>

            </div>
            <div className="right" style={timeStyle}>
                <label
                    style={{
                    color: labelColor,
                    fontSize: '12px',
                    paddingRight: '5px'
                }}>Planned Duration:</label>
                <span style={{
                    fontSize: '12px'
                }}>
                  {duration} minutes
                </span>  
            </div>
        </div>
    );

};

OrderStatusBar.propTypes = {
    orderStatus: PropTypes.object,
    duration: PropTypes.string
};

export default OrderStatusBar;



// WEBPACK FOOTER //
// ./src/components/order-status/OrderStatusBar.js